const IconCheck = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={9}
      height={6}
      fill="none"
      viewBox="0 0 9 6"
    >
      <path
        d="M7.75 0.75L3.08333 4.75L0.75 2.75" stroke="#00AAAA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
  )
}

export default IconCheck;
